import { assign } from 'xstate5';

import { optimizeIncludedSlots as optimize } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * After any modification change, ensures extras are moved into free
 * included slots and originally-included items reclaim their slots
 * from downgraded guests.
 */
export const optimizeIncludedSlots: CustomizationMachineAction = assign((args) => {
  const { context } = args;

  const {
    includedModificationsMap,
    extrasModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
    modifications,
    isUpsellPricingEnabled,
  } = context;

  if (!isUpsellPricingEnabled || !modifications) return {};

  const updatedActives = optimize({
    activeModifications: modifications.active,
    initialModifications: modifications.initial,
    includedModificationsMap,
    extrasModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
  });

  if (updatedActives === modifications.active) return {};

  return { modifications: { ...modifications, active: updatedActives } };
});
